<template>
  <div>
    <div class="content">
      <div class="cont-list">
        <span class="list">{{
          this.$route.query.name + "-" + this.route.name
        }}</span>
        <!-- <span class="masge">当前共有{{ total }}位成员</span> -->
      </div>
      <div class="header">
        <div class="left">
          <el-button v-if="tableAcl.indexOf('Add') != -1" class="btn primary" type="primary" size="small" v-preventReClick @click="handleAdd">新增流程</el-button>
          <el-button v-if="tableAcl.indexOf('Add') != -1" class="btn primary" type="primary" size="small" v-preventReClick @click="goBack()">返回上一级</el-button>
          <!-- <el-button class="btn" size="small" :disabled="multiple" v-preventReClick
            @click="handleDelete">
            {{cancelButtonText}}
          </el-button> -->
        </div>
        <!-- <div class="right">
          <div class="search">
            <input type="text" v-model="query.keyWord"  />
            <i class="el-icon-search padding10" v-preventReClick
            @click="queryChange"></i>
          </div>
          <span v-preventReClick
            @click="reset">重置</span>
        </div> -->
      </div>

      <el-table ref="multipleTable" border row-key="id" :data="tableData" :max-height="tableHeight" style="width: 100%" @selection-change="handleSelectionChange" stripe :header-cell-style="{ background: '#DDEBFF' }">
        <el-table-column align="center" :reserve-selection="true" type="selection" fixed width="55">
        </el-table-column>
        <el-table-column prop="name" label="流程名称" min-width="140">
        </el-table-column>
        <el-table-column prop="stateName" label="状态" min-width="80">
          <template slot-scope="scope">
            <span :class="{ enable: scope.row.state == 1 }">{{
              scope.row.state == 1 ? "当前启用" : "备用"
            }}</span>
          </template>
        </el-table-column>
        <el-table-column prop="createdTime" label="创建时间" width="170">
          <template slot-scope="scope">
            {{ parseTime(new Date(scope.row.createdTime)) }}
          </template>
        </el-table-column>
        <el-table-column prop="operation" label="操作" width="120">
          <template slot-scope="scope">
            <el-button v-if="tableAcl.indexOf('Edit') != -1" type="text" v-preventReClick @click="handleUpdate(scope.row)" class=" color-blue">查看</el-button>
            <el-button v-if="tableAcl.indexOf('Remove') != -1" type="text" v-preventReClick @click="handleDelete(scope.row)" class="margin-left20 color-blue">{{ scope.row.state === 0 ? "启用" : "禁用" }}</el-button>
          </template>
        </el-table-column>
      </el-table>
    </div>
    <div class="pagination">
      <el-pagination background layout="sizes, prev, pager, next, jumper" :page-sizes="[10, 20, 50, 100, 200, 500, 1000]" :page-size="query.pageSize" @size-change="handleSizeChange" :current-page="query.pageIndex" :total="total" @current-change="changePage">
      </el-pagination>
    </div>
  </div>
</template>

<script>
import { GetWorkFlowTemps, UpdateWorkFlowTempStatesById } from "@/api";
import GetDataMixin from "@/mixin/getData-mixin.js";
// import SelectUser from './select-user';

export default {
  mixins: [GetDataMixin],
  components: {
    // SelectUser
  },
  data () {
    return {
      // 查询条件
      query: {
        keyWord: "",
        pageSize: 10,
        pageIndex: 1,
      },
      // 列表数据
      tableData: [],
      // 列表总数
      total: 0,
      // 弹出框标题
      title: "",
      // 弹出编辑框
      open: false,
      // 打开详情
      showInfo: false,
      id: 0,
      // 新增、编辑的数据
      form: {},
      // 多选框数据
      ids: [],
      multipleSelection: [],
      // 列表多选
      multiple: true,
      cancelButtonText: "禁用",
      moduleId: 0,
      appId: 0,
    };
  },
  created () {
    var query = this.$route.query;
    if (query.id) {
      this.query.workFlowCardId = query.id;
    }
    if (query.moduleId) {
      this.moduleId = query.moduleId;
    }
    if (query.appId) {
      this.appId = query.appId;
    }
  },
  methods: {
    handleSelectionChange (selection) {
      this.multipleSelection = selection;
      this.ids = selection.map((item) => item.id);
      this.multiple = !selection.length;

      this.cancelButtonText =
        selection && selection.length > 0 && selection[0].state == 0
          ? "启用"
          : "禁用";
    },
    // 获取列表
    getData () {
      GetWorkFlowTemps(this.query).then((res) => {
        this.tableData = res.returnData.data;
        this.total = res.returnData.totalCount;
      });
    },
    // 查看信息
    handleInfo (row) {
      this.id = row.id;
      this.showInfo = true;
    },
    closeInfo () {
      this.showInfo = false;
      this.id = 0;
    },
    // 新建
    handleAdd () {
      this.$router.push(
        "/workflow-edit?workFlowCardId=" +
        this.query.workFlowCardId +
        "&moduleId=" +
        this.moduleId +
        "&name=" +
        this.$route.query.name +
        "&isMedicine=" +
        this.$route.query.isMedicine
      );
    },
    // 编辑
    handleUpdate (row) {
      this.$router.push(
        "/workflow-edit?id=" +
        row.id +
        "&moduleId=" +
        this.moduleId +
        "&name=" +
        this.$route.query.name+
        "&isMedicine=" +
        this.$route.query.isMedicine
      );
    },
    resetForm () {
      this.form = {
        name: "",
        state: true,
        appId: this.appId,
        orgCode :sessionStorage.getItem('orgId'),
      };
    },
    // 取消编辑部门
    cancel () {
      this.open = false;
    },
    // 改变当前页
    changePage (val) {
      this.$set(this.query, "pageIndex", val);
      this.getData();
    },
    handleSizeChange (val) {
      this.$set(this.query, "pageSize", val);
      this.getData();
    },

    // 删除部门
    handleDelete (row) {
      // let ids = [];
      let state = 0;
      if (row && row.id) {
        // ids = [row.id]
        state = row.state == 1 ? 0 : 1;
      }

      this.$my_confirm("此操作将切换状态, 是否继续?", "提示", {
        type: "warning",
      })
        .then(() => {
          return UpdateWorkFlowTempStatesById({ id: row.id, state });
        })
        .then(() => {
          this.$my_message(`操作成功！`, "success");
          this.getData();
        })
        .catch(() => { });
    },
    // 重置
    reset () {
      this.query.keyWord = "";
      this.$set(this.query, "pageIndex", 1);
      this.$set(this.query, "pageSize", 10);
      this.getData();
    },
    queryChange () {
      this.$set(this.query, "pageIndex", 1);
      this.getData();
    },
    goBack () {
      this.$router.push("/workflow?appId=" + this.appId);
    },
    // deptChange (val) {
    //   this.form.parentId = val
    // },
    // userChange (val) {
    //   this.form.leader = val
    // }
  },
  mounted () {
    this.getData();
    // this.getDepts('');
    // this.getUsers('');
  },
};
</script>

<style lang="scss" scoped></style>
